class Monitoring.Models.ContentBeautifier

  constructor: (@content) ->
    # nothing to do

  replace: (regex, replacement_pattern) ->
    # replacement_pattern should be something like: 'my new content with %{match} and other stuff'
    content_regex_matcher = new ContentBeautifier.RegexMatcher(@content)
    matches = content_regex_matcher.matches_of(regex)
    content_translator = new ContentBeautifier.Translator(@content, replacement_pattern)
    content_translator.replace(matches)
